<template>
  <div class="drawerCard">
    <div class="drawerCardBody">
      <slot />
    </div>
    <div v-if="hasActions" class="drawerCardActions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSlots } from 'vue'

const slots = useSlots()
const hasActions = Boolean(slots.actions)
</script>

<style scoped>
.drawerCard {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.drawerCardBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.drawerCardActions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-2);
  padding-top: var(--space-3);
  border-top: 1px solid var(--color-border-subtle);
}
</style>
